import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { RolTreeComponent } from "./roltree";
import { obtenerArbolRolesFiltrado, FiltroRol, } from "./logic";
import { FiltroRolComponent } from "./filtro";
import { DeclaracionRoles } from "../rolmap";

type Entity = models.Rol;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

export interface State {
    filtro: FiltroRol;
}

/**
* Componente para editar un Entity
*/
export class RolTreeFiltradoComponent extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);

        this.state = { filtro: {} }
    }
    value = (props: Props) => props.value;

    render() {
        const { value } = this.props;
        const tree = obtenerArbolRolesFiltrado(value, this.state.filtro);

        return (
            <div>
                <kea.Title titulo="Permisos" size="h4" />
                <FiltroRolComponent value={this.state.filtro} onChange={x => this.setState({ filtro: x })} />
                <RolTreeComponent value={value} onChange={this.props.onChange} tree={tree} fullTree={DeclaracionRoles} depth={0} />
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/edit/componentes/roltreefiltrado.tsx